import BotErrorImage from '@/assets/bot-error-image.webp'
import OpacityAnimation from '@/components/animations/OpacityAnimation'
import { Column, Text } from '@/components/core'
import AvatarCard from '@/components/layout/AvatarCard.tsx'

export default function DemoAccessExpired() {
  return (
    <OpacityAnimation className="h-screen w-full">
      <Column className="h-full w-full items-center justify-center">
        {/* AvatarCard takes 80% x 70% of this box on lg screens */}
        <Column className="h-full max-h-[900px] w-full max-w-[900px] items-center justify-center">
          <AvatarCard variant="image" botAvatar={BotErrorImage} animate={false}>
            <Column className="items-center">
              <Text.Translated
                size="3xl"
                className="!text-electric-indigo-900"
                fontWeight="bold"
                align="center"
                translationKey="title_demo_access_expired"
              />
              <Text.Translated
                color="600"
                align="center"
                className="my-[18px] text-lg"
                translationKey="message_demo_access_expired"
              />
            </Column>
          </AvatarCard>
        </Column>
      </Column>
    </OpacityAnimation>
  )
}
